import React, {useEffect} from 'react';
import './blog.css';
import {Link} from "react-router-dom";
import { Helmet } from "react-helmet-async";

import {A11y, Keyboard, Navigation, Pagination} from "swiper";
import {Swiper, SwiperSlide} from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {blogData} from "../../Data";
import Aos from "aos";
import 'aos/dist/aos.css';
import { FiArrowUpRight } from "react-icons/fi";

const Blog = ({observer, sectionRef}) => {
    const ABS_BASE = "https://www.artdesignyana.com";
    const abs = (path = "") => (path?.startsWith("http") ? path : `${ABS_BASE}${path || ""}`);

    const jsonLd = (() => {
        // limit to first 10 for cleanliness (Google’s fine with more, but no need to overdo)
        const posts = blogData.slice(0, 10);

        return {
            "@context": "https://schema.org",
            "@type": "ItemList",
            "itemListElement": posts.map((post, idx) => ({
                "@type": "ListItem",
                "position": idx + 1,
                "url": abs(post.path),
                "item": {
                    "@type": "BlogPosting",
                    "headline": post.title,
                    "image": post.img ? [abs(post.img)] : undefined,
                    "description": post.description,
                    // If you have dates in Data.jsx, add them; otherwise omit
                    "datePublished": post.datePublished,         // e.g., "2025-07-21"
                    // If you have author name, add it; else use brand
                    "author": { "@type": "Person", "name": post.author || "Yana Trofimova" },
                    "publisher": {
                        "@type": "Organization",
                        "name": "ArtDesignYana",
                        "logo": { "@type": "ImageObject", "url": abs("/og-logo.png") }
                    },
                    "mainEntityOfPage": abs(post.path),
                    "url": abs(post.path)
                }
            }))
        };
    })();

    useEffect(() => {
        Aos.init({duration: 1500})
    }, [])

    useEffect(() => {
        if (observer) {
            observer.observe(sectionRef.current)
        }
    }, [sectionRef, observer])

    return (
        <section id='blog'>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            </Helmet>
            <div data-aos='fade-up' data-aos-duration='2000' className='blog_header'>
                <h2 className="eyebrow">Blog</h2>
                <h1>My recent posts</h1>
            </div>
            <div data-aos='zoom-in' data-aos-duration='2000' className='container blog_container' id='blog_swiper'
                 ref={sectionRef}>
                <Swiper
                    modules={[Pagination, Navigation, Keyboard, A11y]}
                    style={{
                        "--swiper-navigation-color": "var(--color-bg-footer)",
                        "--swiper-pagination-color": "var(--color-bg-footer)",
                    }}
                    breakpoints={{
                        0: {slidesPerView: 1, slidesPerGroup: 1},
                        600: {slidesPerView: 2, slidesPerGroup: 2},
                        1024: {slidesPerView: 3, slidesPerGroup: 3}
                    }}
                    // slidesPerView={3}
                    // slidesPerGroup={3}
                    spaceBetween={30}
                    loop={true}
                    keyboard={{enabled: true}}
                    a11y={{enabled: true}}
                    // loopFillGroupWithBlank={true}
                    pagination={{clickable: true, dynamicBullets: true}}
                    navigation={true}
                    // className="bigSwiper"
                >
                    {
                        blogData.map((post, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <article className="blog_card">
                                        <img
                                            className='blog_img'
                                            src={post.img}
                                            alt={post.title || 'Blog post'}
                                            loading="lazy"
                                            decoding="async"
                                        />
                                        <div className="text">
                                            <div className="title"><h3>{post.title}</h3></div>
                                            <p className="blog_excerpt">{post.description}</p>
                                            <Link to={post.path} className='blog_link'>Read article
                                                <FiArrowUpRight />
                                            </Link>
                                        </div>
                                    </article>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
            </div>
        </section>
    )
};

export default Blog;
